import ActivatePage from './ActivatePage';
export default ActivatePage;
